require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./flyout"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./flyout"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./flyout")) : factory(root["./utils"], root["./svgicon"], root["./flyout"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__25__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[31],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-iconpicker{position:relative;display:flex;height:24px;width:24px;font-size:.875rem;background-color:#fff;background-color:hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1)}.ba-common-iconpicker .ba-common-iconpicker__svgIcon{margin:auto}.ba-common-iconpicker__none{background-image:repeating-linear-gradient(135deg, white 0%, white 48%, red 50%, white 52%, white 100%);background-repeat:no-repeat}.ba-common-iconpicker__flyout{padding:.3em;width:200px;flex-wrap:wrap;display:flex;justify-content:flex-start;-ms-high-contrast-adjust:none}.ba-common-iconpicker__cell{display:inline-block;width:16px;height:16px;margin:8px}.ba-common-iconpicker__cell:hover{cursor:pointer}.ba-common-iconpicker__text{width:100%;height:100%;text-align:center}.ba-common-iconpicker__text:hover{cursor:pointer}.ba-common-iconpicker .ba-common-iconpicker__ghost{width:100%;height:100%;display:flex;justify-content:center;color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.6274509804%), 1)}.ba-common-iconpicker .ba-common-iconpicker__ghost:hover{background-color:#fff;background-color:hsla(var(--icon-03-h, 0), var(--icon-03-s, 0%), var(--icon-03-l, 100%), 1);color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.6274509804%), 1)}", ""]);

// exports
exports.locals = {
	"iconpickerClassName": "\"ba-common-iconpicker\""
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__25__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(362);


/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _IconPicker = _interopRequireDefault(__webpack_require__(363));

exports.default = _IconPicker.default;
exports.IconPicker = _IconPicker.default;

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _flyout = _interopRequireDefault(__webpack_require__(25));

var _svgicon = _interopRequireDefault(__webpack_require__(10));

var _baUiCarbon = __webpack_require__(9);

var _utils = __webpack_require__(5);

var _IconPicker = _interopRequireDefault(__webpack_require__(364));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: @ba/ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2020, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const iconpickerClassName = _IconPicker.default.iconpickerClassName.replace(/"/g, '');

const {
  sanitize
} = _utils.propsUtils;
const {
  uniqueId
} = _utils.lodash;

class IconPicker extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_handleOpen", () => {
      this.setState(state => ({
        open: !state.open
      }));
    });
    this.state = {
      open: false
    };
    this._handleSelect = this._handleSelect.bind(this);
    this._handleKey = this._handleKey.bind(this);
    this._id = uniqueId('ba-common-icon-picker__');
    this.attachRef = _react.default.createRef();
  }

  _handleOpenOnKeydown(e) {
    // 13 = Return, 32 = Space
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();

      this._handleOpen();
    }
  }

  _handleSelect(iconSpec) {
    this.props.onIconSelected(iconSpec); // close the flyout after selection

    this.setState(state => ({
      open: !state.open
    }));
  }

  _handleKey(e, iconSpec) {
    // 13 = Return, 32 = Space
    if (e.keyCode === 13 || e.keyCode === 32) {
      this._handleSelect(iconSpec); // Prevent browser's default action: space does a PageDown


      e.preventDefault();
    }
  }

  _displayIcon(iconSpec = {}, index) {
    const {
      iconExtraOptions
    } = this.props;
    const {
      className,
      size,
      tabIndex,
      verticalAlign,
      ...others
    } = iconExtraOptions;
    const {
      icon
    } = iconSpec;
    const displayGhostButton = icon.id === 'none';
    const classnames = (0, _utils.classnames)(displayGhostButton ? `${iconpickerClassName}__text` : `${iconpickerClassName}__cell`, `${className}`);
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      key: index,
      tabIndex: tabIndex,
      className: classnames,
      onClick: () => this._handleSelect(iconSpec),
      onKeyDown: e => this._handleKey(e, iconSpec),
      title: iconSpec.label
    }, sanitize(others, IconPicker)), displayGhostButton ? /*#__PURE__*/_react.default.createElement(_baUiCarbon.Button, {
      kind: "ghost",
      size: "small",
      tabIndex: tabIndex,
      className: `${iconpickerClassName}__ghost`,
      onClick: () => this._handleSelect(iconSpec),
      onKeyDown: e => this._handleKey(e, iconSpec)
    }, iconSpec.label) : /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      iconId: icon.id,
      alt: iconSpec.label,
      ariaLabelledby: uniqueId('icon-picker-svg'),
      size: size,
      verticalAlign: verticalAlign
    }));
  }

  render() {
    const {
      open
    } = this.state;
    const {
      className,
      disabled,
      icons,
      selectedIcon,
      style,
      buttonExtraOptions,
      flyoutExtraOptions,
      ...others
    } = this.props;
    let {
      orientation
    } = this.props;

    if (typeof orientation === 'undefined') {
      orientation = document.body.dir === 'rtl' ? 'bottomLeft' : 'bottomRight';
    }

    const classNames = `${iconpickerClassName}${className.length > 0 ? ` ${className}` : ''}${selectedIcon.icon.id === '' ? ` ${iconpickerClassName}__none` : ''}`;
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, sanitize(others, IconPicker), {
      className: classNames,
      ref: this.attachRef,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_svgicon.default, (0, _extends2.default)({
      tabIndex: 0,
      "data-tid": "ba-common-icon-picker__button",
      disabled: disabled,
      className: `${iconpickerClassName}__svgIcon`,
      iconId: selectedIcon.icon.id,
      onClick: !disabled ? this._handleOpen : undefined,
      onKeyDown: !disabled ? e => this._handleOpenOnKeydown(e) : undefined
    }, buttonExtraOptions)), open && /*#__PURE__*/_react.default.createElement(_flyout.default, (0, _extends2.default)({
      id: `${this._id}-flyout`,
      "data-tid": "ba-common-icon-picker__flyout"
    }, flyoutExtraOptions, {
      "aria-hidden": open,
      placement: orientation,
      domNodeToAttachTo: this.attachRef.current,
      hideArrow: true,
      offset: 2,
      onClose: this._handleOpen,
      className: `${iconpickerClassName}__flyout`
    }), icons.map(this._displayIcon.bind(this))));
  }

}

exports.default = IconPicker;
(0, _defineProperty2.default)(IconPicker, "propTypes", {
  /** Custom class name(s) */
  className: _propTypes.default.string,

  /** Flag to disable the icon picker */
  disabled: _propTypes.default.bool,

  /** Icons to be selected */
  icons: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.shape({
      id: _propTypes.default.string.isRequired
    }).isRequired,
    iconId: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired
  })).isRequired,

  /** Flyout.propTypes.placement */
  orientation: _flyout.default.propTypes.placement,

  /** Function that will get called on click of a icon */
  onIconSelected: _propTypes.default.func.isRequired,

  /** Selected icon to show */
  selectedIcon: _propTypes.default.shape({
    icon: _propTypes.default.shape({
      id: _propTypes.default.string.isRequired
    }).isRequired,
    iconId: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired
  }).isRequired,

  /** Custom css styles */
  style: _propTypes.default.object,

  /** Extra options for the svg click to open/close the flyout */
  buttonExtraOptions: _propTypes.default.object,

  /** Extra options for the svg to pass to Flyout */
  iconExtraOptions: _propTypes.default.shape({
    className: _propTypes.default.string,
    size: _propTypes.default.string,
    tabIndex: _propTypes.default.number,
    verticalAlign: _propTypes.default.string
  }),

  /** Extra options to pass to Flyout */
  flyoutExtraOptions: _propTypes.default.object
});
(0, _defineProperty2.default)(IconPicker, "defaultProps", {
  disabled: false,
  className: '',
  style: {},
  buttonExtraOptions: {},
  iconExtraOptions: {
    tabIndex: 0,
    className: '',
    verticalAlign: 'inherit'
  },
  flyoutExtraOptions: {}
});

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_IconPicker_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(115);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_IconPicker_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_IconPicker_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_IconPicker_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_IconPicker_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ })

},[[361,0]]]);
});